<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!-- 搜索 -->
      <div>
        <el-input
          style="width: 300px; margin-right: 10px"
          prefix-icon="el-icon-edit"
          v-model="custName"
          size="mini"
          placeholder="请输入客户名称"
          clearable
        >
        </el-input>
        <!-- <el-select
          v-model="industry"
          placeholder="请选择行业"
          style="width: 250px"
          size="mini"
          clearable
        >
          <el-option
            v-for="item in industrys"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select> -->
        <span style="margin-right: 10px"></span>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onSearch"
          style="margin-left: 10px"
          size="mini"
          >搜索
        </el-button>
      </div>
      <!-- 右边工具  添加新客户  -->
      <div>
        <el-button
          type="success"
          @click="downloadExcel"
          style="margin-left: 10px"
          size="mini"
          v-if="qx1"
        >
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出数据</el-button
        >
        <el-button
          v-if="qx"
          type="success"
          icon="el-icon-user"
          @click="addCust"
          size="mini"
          >添加客户信息</el-button
        >
      </div>
    </div>

    <!-- 表格    @row-click  单击    @row-dblclick 双击
		-->
    <div style="margin-top: 20px">
      <el-table
        :data="queryData"
        stripe
        border
        :cell-style="{ padding: '5px 0' }"
        fit
        id="mytable"
        @row-dblclick="updateRecordView"
        size="mini"
        v-loading="loading"
        :row-style="{ height: '58px' }"
        height="calc(100vh - 250px)"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :header-cell-style="{
          background: '#eef1f6',
          color: '#606266',
          borderColor: 'white',
        }"
        style="width: 100%"
      >
        <!-- 多选框 -->
        <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
        <el-table-column
          prop="custName"
          label="客户名称"
          align="center"
          width="320"
        >
        </el-table-column>
        <el-table-column
          prop="industryName"
          label="行业"
          align="center"
          width="180"
        >
          <template slot="header">
            <el-select
              v-model="industry"
              placeholder="请选择行业"
              size="mini"
              clearable
              @change="onSearch"
            >
              <el-option
                v-for="item in industrys"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span :class="getIndustryClass(scope.row.industryName)">{{ scope.row.industryName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="custManagerName"
          label="销售人员"
          align="center"
          width="180"
        >
          <template slot="header">
            <el-select
              v-model="custManagerId"
              placeholder="请选择销售人员"
              size="mini"
              clearable
              @change="onSearch"
              :disabled="qx"
            >
              <el-option
                v-for="item in custManagers"
                :key="item.id"
                :label="item.uname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            {{ scope.row.custManagerName }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="客户地址" align="center">
        </el-table-column>
        <el-table-column label="所在区域" align="center" width="160">
          <template slot="header">
            <el-select
              v-model="region"
              placeholder="请选择区域"
              size="mini"
              clearable
              @change="onSearch"
            >
              <el-option
                v-for="item in regionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.provinceName }}-{{ scope.row.cityName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          align="center"
          width="160"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
        </el-table-column>
        <!-- 	<el-table-column label="状态" align="center" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.state==0">正常</span>
						<span style="font-size: 10px" v-if="scope.row.income>0">流失</span>
					</template>
				</el-table-column> -->
        <!-- <el-table-column label="操作" align="center" fixed="right" width="60">  -->
        <!--  <el-table-column label="操作" align="center" width="80" v-if="zjl_qx">  -->
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              content="添加联系人"
              placement="top"
            >
              <el-button
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-circle-plus-outline"
                @click="ViewAddLinkRecord(scope.row)"
              ></el-button>
            </el-tooltip>

            <el-tooltip
              v-if="qx1"
              class="item"
              effect="light"
              content="指派客户"
              placement="top"
            >
              <!--   指派第一个参数 index 暂时无用 赋值为1  -->
              <el-button
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-thumb"
                @click="assignManager(1, scope.row)"
              ></el-button>
            </el-tooltip>
            <!-- <el-tooltip class="item" effect="light" content="将该商机置为丢标状态" placement="top">
							<el-button style="float: none; padding: 3px 0;color: #ff0000" type="text" icon="el-icon-circle-close" @click="setRecord(scope.row)"></el-button>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="删除该记录" placement="top">
							<el-button style="float: none; padding: 3px 0;color: #ff0000" type="text" icon="el-icon-delete" @click="deleteRecord(scope.row)"></el-button>
						</el-tooltip> -->

            <!-- <el-button type="primary" size="mini" style="margin-right: 8px;"
							@click="showLinkManView(scope.row)">联系人</el-button> -->
            <!-- <el-button type="primary" size="mini" @click="showEditView(scope.row)" :disabled="kaiguan(scope.row.createTime)">编辑</el-button> -->
            <!-- <el-button type="danger" size="mini" style="padding: 2px">更多</el-button> -->
            <!-- <el-dropdown size="mini" split-button type="danger" split-button @command="handleCommand">
							更多
							<el-dropdown-menu divided="false" slot="dropdown">
								<el-dropdown-item :command="beforeHandleCommand(scope.$index,scope.row,'a')">修改客户信息
								</el-dropdown-item>
								<el-dropdown-item :command="beforeHandleCommand(scope.$index,scope.row,'b')">指派销售人员
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown> -->
            <!-- <el-button type="danger" @click="deleteRecord(scope.row)" size="mini" :disabled="kaiguan(scope.row.createTime)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 100, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>

    <!--    第二层弹出框 点击圆形按钮    linkmanDialogVisible:是否弹出  联系人录入   showClose 将对话框的叉号去掉 -->
    <el-dialog
      title=""
      :visible.sync="linkmanDialogVisible"
      width="85%"
      top="1px"
      :showClose="showClo"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <!-- 通过样式将对话框隐藏 -->
      <el-card
        class="box-card"
        style="
          margin-top: -60px;
          margin-left: -20px;
          margin-right: -20px;
          margin-bottom: -30px;
        "
      >
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: bold">联系人录入</div>
          <div>
            <el-button size="mini" @click="doChanceLxr">取 消</el-button>
            <el-button size="mini" type="primary" @click="doAddLinkRecord"
              >提交记录</el-button
            >
          </div>
        </div>
        <hr
          style="
            background-color: #eaeaea;
            color: #eaeaea;
            height: 1px;
            border: 1px none #000000;
          "
        />
        <div>
          <!-- 增加一层 el-form表单，可以数据校验 -->
          <el-form
            ref="inputCustLinkForm"
            :model="inputCustLinkObj"
            :rules="rules3"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="所属客户名称">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 800px"
                    :disabled="true"
                    v-model="myCustName"
                    placeholder="请输入客户名称"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="联系人姓名" prop="linkName">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj.linkName"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="性别" prop="sex">
                  <el-select
                    v-model="inputCustLinkObj.sex"
                    placeholder="请选择性别"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in sexs"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="部门" prop="department">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj.department"
                    placeholder="请输入部门"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="职务" prop="job">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj.job"
                    placeholder="请输入职务"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!--   &nbsp;   &ensp;  &emsp;  &thinsp；       -->
            <el-row>
              <el-col :span="6">
                <el-form-item
                  label="关系程度"
                  prop="relDegree"
                  style="margin-left: 22px"
                >
                  <el-select
                    v-model="inputCustLinkObj.relDegree"
                    placeholder="请选择关系程度"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in relDegrees"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="权能" prop="power">
                  <el-select
                    v-model="inputCustLinkObj.power"
                    placeholder="请选择权能"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in powers"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="爱好"
                  prop="hobby"
                  style="margin-left: 10px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 448px"
                    v-model="inputCustLinkObj.hobby"
                    placeholder="请输入爱好"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="办公地址"
                  prop="officeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj.officeAddress"
                    placeholder="请输入办公地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  label="办公电话"
                  prop="telephone"
                  style="margin-left: 12px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj.telephone"
                    placeholder="请输入办公电话"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="家庭地址"
                  prop="homeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj.homeAddress"
                    placeholder="请输入家庭地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="联系方式" prop="phone">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj.phone"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="备注描述"
                  prop="remark"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="textarea"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj.remark"
                    placeholder="请输入备注信息"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <!-- <span slot="footer" class="dialog-footer">
				<el-button @click="doChance">取 消</el-button>
				<el-button type="primary" @click="doAddLinkRecord">确 定</el-button>
			</span> -->
    </el-dialog>

    <!-- 第一层弹出框 点击“添加客户信息”按钮  dialogVisible:是否弹出   新增客户与联系人 -->
    <el-dialog
      title="添加新客户与联系人"
      :visible.sync="dialogVisible"
      width="80%"
      top="1px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <!-- 客户基本信息 -->
      <el-card class="box-card" style="margin-top: -20px">
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: bold">客户基本信息</div>
          <!-- <el-button @click="doChance">取 消</el-button> -->
          <el-button size="mini" type="primary" @click="doAddRecord"
            >提交客户信息</el-button
          >
        </div>
        <hr
          style="
            background-color: #eaeaea;
            color: #eaeaea;
            height: 1px;
            border: 1px none #000000;
          "
        />
        <div>
          <!-- 增加一层 el-form表单，可以数据校验 -->
          <el-form ref="inputCustForm" :model="inputCustObj" :rules="rules">
            <el-row>
              <el-col :span="12">
                <el-form-item label="客户名称" prop="custName">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 340px"
                    v-model="inputCustObj.custName"
                    placeholder="请输入客户名称"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="所属行业" prop="industry">
                  <el-select
                    v-model="inputCustObj.industry"
                    placeholder="请选择所属行业"
                    size="mini"
                    style="width: 340px"
                  >
                    <el-option
                      v-for="item in industrys"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="所属省市" prop="city">
                  <el-select
                    v-model="inputCustObj.province"
                    placeholder="请选择省份"
                    size="mini"
                    @change="provinceChange"
                    style="width: 170px"
                  >
                    <el-option
                      v-for="item in provinces"
                      :key="item.provinceCode"
                      :label="item.provinceName"
                      :value="item.provinceCode"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    v-model="inputCustObj.city"
                    placeholder="请选择地市"
                    size="mini"
                    style="width: 170px"
                  >
                    <el-option
                      v-for="item in citys"
                      :key="item.cityCode"
                      :label="item.cityName"
                      :value="item.cityCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="客户地址" prop="address">
                  <div style="display: flex; align-items: center;">
                    <el-input
                      type="text"
                      size="mini"
                      prefix-icon="el-icon-edit"
                      style="width: 280px"
                      v-model="inputCustObj.address"
                      :placeholder="inputCustObj.address ? '可手动修改地址' : '请通过地图定位获取'"
                    ></el-input>
                    <el-button
                      type="primary"
                      size="mini"
                      style="margin-left: 8px;"
                      @click="openMapLocation('add')"
                    >
                      <i class="el-icon-location"></i> 地图定位
                    </el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="经度">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-map-location"
                    style="width: 340px"
                    v-model="inputCustObj.longitude"
                    placeholder="通过地图定位获取"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="纬度">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-map-location"
                    style="width: 340px"
                    v-model="inputCustObj.latitude"
                    placeholder="通过地图定位获取"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="phone">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 340px"
                    v-model="inputCustObj.phone"
                    placeholder="请输入客户联系电话"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="邮政编码" prop="postCode">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 340px"
                    v-model="inputCustObj.postCode"
                    placeholder="请输入客户邮政编码"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <!-- 添加联系人圆形按钮	 -->
      <div style="margin-top: 12px; display: flex; justify-content: flex-end">
        <span style="margin-top: 12px"
          >先提交客户信息，再点击按钮添加联系人</span
        >
        <el-button
          @click="ViewAddLinkRecord"
          :disabled="add_lxr"
          type="primary"
          icon="el-icon-circle-plus-outline"
          style="font-size: 22px; margin-right: 15px; margin-left: 15px"
          circle
        ></el-button>
      </div>

      <!-- 联系人清单列表	 -->
      <el-card class="box-card" style="margin-top: 16px">
        <div style="margin-top: 1px">
          <div style="display: flex; justify-content: space-between">
            <div style="font-weight: bold">联系人清单</div>
          </div>
          <hr
            style="
              background-color: #eaeaea;
              color: #eaeaea;
              height: 1px;
              border: 1px none #000000;
            "
          />
          <el-table
            :data="queryLinkData"
            stripe
            :row-style="{ height: '10px' }"
            :cell-style="{ padding: '5px 0' }"
            size="mini"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            style="width: 100%"
          >
            <!-- 多选框 -->
            <!-- <el-table-column type="selection" align="center" width="55"></el-table-column> -->
            <el-table-column
              prop="linkName"
              label="联系人姓名"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="sexName"
              label="性别"
              align="center"
              width="60"
            >
            </el-table-column>
            <el-table-column
              prop="custName"
              label="归属客户"
              align="center"
              width="320"
            >
            </el-table-column>
            <el-table-column
              prop="department"
              label="部门"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column prop="job" label="职务" align="center" width="120">
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="telephone"
              label="办公电话"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="officeAddress"
              label="办公地址"
              align="center"
              width="320"
            >
            </el-table-column>
            <el-table-column
              prop="relDegreeName"
              label="关系程度"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="powerName"
              label="权能"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="hobby"
              label="爱好"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="创建日期"
              align="center"
              width="150"
            
            :formatter="dateTimeTwoLine"
            class-name="cell-two-line"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
              fixed="right"
              width="60"
            >
              <template slot-scope="scope">
                <el-button
                  style="float: none; padding: 3px 0; color: #ff0000"
                  type="text"
                  icon="el-icon-delete"
                  @click="deleteRecord(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </el-dialog>

    <!-- 相似客户提示弹窗 -->
    <el-dialog
      title="相似客户提示"
      :visible.sync="similarDialogVisible"
      width="1200px"
      top="15%"
      :close-on-click-modal="false"
    >
      <p style="margin-bottom: 10px; color: #E6A23C;">
        <i class="el-icon-warning"></i>
        客户名称: {{ currentInputCustName }}，该客户名称已有以下相似客户，是否继续添加？
      </p>
      <el-table :data="similarCustomerList" border size="mini" max-height="350">
        <el-table-column prop="name" label="客户名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="相似度" width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.score >= 0.8" type="danger" size="mini">很相似</el-tag>
            <el-tag v-else-if="scope.row.score >= 0.5" type="warning" size="mini">部分相似</el-tag>
            <el-tag type="success" v-else>略微相似</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="industry" label="所属行业" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="city" label="所在城市" width="100" align="center"></el-table-column>
        <el-table-column prop="address" label="地址" width="300" align="center"></el-table-column>
        <el-table-column label="认领状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.claimStatus === 1" type="success" size="mini">已认领</el-tag>
            <el-tag v-else type="info" size="mini">未认领</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="custManagerName" label="认领人" width="100" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="similarDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="confirmAddAfterSimilarCheck">继 续 添 加</el-button>
      </div>
    </el-dialog>

    <!-- 第一层弹出框  双击后修改客户与联系人  updateDialogVisible:是否弹出     -->
    <el-dialog
      title="编辑客户与客户联系人资料"
      :visible.sync="updateDialogVisible"
      width="80%"
      top="1px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <!-- 编辑客户 -->
      <el-card class="box-card" style="margin-top: -20px">
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: bold">客户基本信息</div>
          <!-- <el-button @click="doChance">取 消</el-button> -->
          <el-button
            size="mini"
            type="primary"
            @click="doUpdateRecord"
            v-if="qx"
            >保存客户信息</el-button
          >
        </div>
        <hr
          style="
            background-color: #eaeaea;
            color: #eaeaea;
            height: 1px;
            border: 1px none #000000;
          "
        />
        <div>
          <!-- 增加一层 el-form表单，可以数据校验 -->
          <el-form ref="inputXgCustForm" :model="inputXgCustObj" :rules="rules">
            <el-row>
              <el-col :span="12">
                <el-form-item label="客户名称" prop="custName">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 340px"
                    v-model="inputXgCustObj.custName"
                    placeholder="请输入客户名称"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="所属行业">
                  <el-select
                    v-model="inputXgCustObj.industry"
                    placeholder="请选择所属行业"
                    size="mini"
                    style="width: 340px"
                  >
                    <el-option
                      v-for="item in industrys"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="所属省市" prop="city">
                  <el-select
                    v-model="inputXgCustObj.province"
                    placeholder="请选择省份"
                    size="mini"
                    @change="provinceChange2"
                    style="width: 170px"
                  >
                    <el-option
                      v-for="item in provinces"
                      :key="item.provinceCode"
                      :label="item.provinceName"
                      :value="item.provinceCode"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    v-model="inputXgCustObj.city"
                    placeholder="请选择地市"
                    size="mini"
                    style="width: 170px"
                  >
                    <el-option
                      v-for="item in citys"
                      :key="item.cityCode"
                      :label="item.cityName"
                      :value="item.cityCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="客户地址" prop="address">
                  <div style="display: flex; align-items: center;">
                    <el-input
                      type="text"
                      size="mini"
                      prefix-icon="el-icon-edit"
                      style="width: 280px"
                      v-model="inputXgCustObj.address"
                      :placeholder="inputXgCustObj.address ? '可手动修改地址' : '请通过地图定位获取'"
                      
                    ></el-input>
                    <el-button
                      type="primary"
                      size="mini"
                      style="margin-left: 8px;"
                      @click="openMapLocation('update')"
                    >
                      <i class="el-icon-location"></i> 地图定位
                    </el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="经度">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-map-location"
                    style="width: 340px"
                    v-model="inputXgCustObj.longitude"
                    placeholder="通过地图定位获取"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="纬度">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-map-location"
                    style="width: 340px"
                    v-model="inputXgCustObj.latitude"
                    placeholder="通过地图定位获取"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="phone">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 340px"
                    v-model="inputXgCustObj.phone"
                    placeholder="请输入客户联系电话"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="邮政编码" prop="postCode">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 340px"
                    v-model="inputXgCustObj.postCode"
                    placeholder="请输入客户邮政编码"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <!-- 编辑联系人1 -->
      <el-card
        v-if="Link1"
        class="box-card"
        style="
          margin-top: 10px;
          margin-left: 0px;
          margin-right: 0px;
          margin-bottom: 0px;
        "
      >
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: bold">
            联系人: {{ inputCustLinkObj1.linkName }}
          </div>
          <div>
            <el-button
              size="mini"
              type="danger"
              @click="DeleteLinkRecord(1)"
              v-if="qx"
              >删除记录</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="SaveLinkRecord(1)"
              v-if="qx"
              >保存记录</el-button
            >
          </div>
        </div>
        <hr
          style="
            background-color: #eaeaea;
            color: #eaeaea;
            height: 1px;
            border: 1px none #000000;
          "
        />
        <div>
          <!-- 增加一层 el-form表单，可以数据校验 -->
          <el-form
            ref="inputCustLinkForm1"
            :model="inputCustLinkObj1"
            :rules="rules3"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="所属客户名称">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 800px"
                    :disabled="true"
                    v-model="myCustName"
                    placeholder="请输入客户名称"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="联系人姓名" prop="linkName">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj1.linkName"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="性别" prop="sex">
                  <el-select
                    v-model="inputCustLinkObj1.sex"
                    placeholder="请选择性别"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in sexs"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="部门" prop="department">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj1.department"
                    placeholder="请输入部门"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="职务" prop="job">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj1.job"
                    placeholder="请输入职务"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!--   &nbsp;   &ensp;  &emsp;  &thinsp；       -->
            <el-row>
              <el-col :span="6">
                <el-form-item
                  label="关系程度"
                  prop="relDegree"
                  style="margin-left: 22px"
                >
                  <el-select
                    v-model="inputCustLinkObj1.relDegree"
                    placeholder="请选择关系程度"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in relDegrees"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="权能" prop="power">
                  <el-select
                    v-model="inputCustLinkObj1.power"
                    placeholder="请选择权能"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in powers"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="爱好"
                  prop="hobby"
                  style="margin-left: 10px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 448px"
                    v-model="inputCustLinkObj1.hobby"
                    placeholder="请输入爱好"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="办公地址"
                  prop="officeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj1.officeAddress"
                    placeholder="请输入办公地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  label="办公电话"
                  prop="telephone"
                  style="margin-left: 12px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj1.telephone"
                    placeholder="请输入办公电话"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="家庭地址"
                  prop="homeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj1.homeAddress"
                    placeholder="请输入家庭地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="联系方式" prop="phone">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj1.phone"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="备注描述"
                  prop="remark"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="textarea"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj1.remark"
                    placeholder="请输入备注信息"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <!-- 编辑联系人2 -->
      <el-card
        v-if="Link2"
        class="box-card"
        style="
          margin-top: 10px;
          margin-left: 0px;
          margin-right: 0px;
          margin-bottom: 0px;
        "
      >
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: bold">
            联系人: {{ inputCustLinkObj2.linkName }}
          </div>
          <div>
            <el-button
              size="mini"
              type="danger"
              @click="DeleteLinkRecord(2)"
              v-if="qx"
              >删除记录</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="SaveLinkRecord(2)"
              v-if="qx"
              >保存记录</el-button
            >
          </div>
        </div>
        <hr
          style="
            background-color: #eaeaea;
            color: #eaeaea;
            height: 1px;
            border: 1px none #000000;
          "
        />
        <div>
          <!-- 增加一层 el-form表单，可以数据校验 -->
          <el-form
            ref="inputCustLinkForm2"
            :model="inputCustLinkObj2"
            :rules="rules3"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="所属客户名称">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 800px"
                    :disabled="true"
                    v-model="myCustName"
                    placeholder="请输入客户名称"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="联系人姓名" prop="linkName">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj2.linkName"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="性别" prop="sex">
                  <el-select
                    v-model="inputCustLinkObj2.sex"
                    placeholder="请选择性别"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in sexs"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="部门" prop="department">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj2.department"
                    placeholder="请输入部门"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="职务" prop="job">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj2.job"
                    placeholder="请输入职务"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!--   &nbsp;   &ensp;  &emsp;  &thinsp；       -->
            <el-row>
              <el-col :span="6">
                <el-form-item
                  label="关系程度"
                  prop="relDegree"
                  style="margin-left: 22px"
                >
                  <el-select
                    v-model="inputCustLinkObj2.relDegree"
                    placeholder="请选择关系程度"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in relDegrees"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="权能" prop="power">
                  <el-select
                    v-model="inputCustLinkObj2.power"
                    placeholder="请选择权能"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in powers"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="爱好"
                  prop="hobby"
                  style="margin-left: 10px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 448px"
                    v-model="inputCustLinkObj2.hobby"
                    placeholder="请输入爱好"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="办公地址"
                  prop="officeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj2.officeAddress"
                    placeholder="请输入办公地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  label="办公电话"
                  prop="telephone"
                  style="margin-left: 12px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj2.telephone"
                    placeholder="请输入办公电话"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="家庭地址"
                  prop="homeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj2.homeAddress"
                    placeholder="请输入家庭地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="联系方式" prop="phone">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj2.phone"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="备注描述"
                  prop="remark"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="textarea"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj2.remark"
                    placeholder="请输入备注信息"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <!-- 编辑联系人3 -->
      <el-card
        v-if="Link3"
        class="box-card"
        style="
          margin-top: 10px;
          margin-left: 0px;
          margin-right: 0px;
          margin-bottom: 0px;
        "
      >
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: bold">
            联系人: {{ inputCustLinkObj3.linkName }}
          </div>
          <div>
            <el-button
              size="mini"
              type="danger"
              @click="DeleteLinkRecord(3)"
              v-if="qx"
              >删除记录</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="SaveLinkRecord(3)"
              v-if="qx"
              >保存记录</el-button
            >
          </div>
        </div>
        <hr
          style="
            background-color: #eaeaea;
            color: #eaeaea;
            height: 1px;
            border: 1px none #000000;
          "
        />
        <div>
          <!-- 增加一层 el-form表单，可以数据校验 -->
          <el-form
            ref="inputCustLinkForm3"
            :model="inputCustLinkObj3"
            :rules="rules3"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="所属客户名称">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 800px"
                    :disabled="true"
                    v-model="myCustName"
                    placeholder="请输入客户名称"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="联系人姓名" prop="linkName">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj3.linkName"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="性别" prop="sex">
                  <el-select
                    v-model="inputCustLinkObj3.sex"
                    placeholder="请选择性别"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in sexs"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="部门" prop="department">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj3.department"
                    placeholder="请输入部门"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="职务" prop="job">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj3.job"
                    placeholder="请输入职务"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!--   &nbsp;   &ensp;  &emsp;  &thinsp；       -->
            <el-row>
              <el-col :span="6">
                <el-form-item
                  label="关系程度"
                  prop="relDegree"
                  style="margin-left: 22px"
                >
                  <el-select
                    v-model="inputCustLinkObj3.relDegree"
                    placeholder="请选择关系程度"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in relDegrees"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="权能" prop="power">
                  <el-select
                    v-model="inputCustLinkObj3.power"
                    placeholder="请选择权能"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in powers"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="爱好"
                  prop="hobby"
                  style="margin-left: 10px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 448px"
                    v-model="inputCustLinkObj3.hobby"
                    placeholder="请输入爱好"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="办公地址"
                  prop="officeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj3.officeAddress"
                    placeholder="请输入办公地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  label="办公电话"
                  prop="telephone"
                  style="margin-left: 12px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj3.telephone"
                    placeholder="请输入办公电话"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="家庭地址"
                  prop="homeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj3.homeAddress"
                    placeholder="请输入家庭地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="联系方式" prop="phone">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj3.phone"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="备注描述"
                  prop="remark"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="textarea"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj3.remark"
                    placeholder="请输入备注信息"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <!-- 编辑联系人4 -->
      <el-card
        v-if="Link4"
        class="box-card"
        style="
          margin-top: 10px;
          margin-left: 0px;
          margin-right: 0px;
          margin-bottom: 0px;
        "
      >
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: bold">
            联系人: {{ inputCustLinkObj4.linkName }}
          </div>
          <div>
            <el-button
              size="mini"
              type="danger"
              @click="DeleteLinkRecord(4)"
              v-if="qx"
              >删除记录</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="SaveLinkRecord(4)"
              v-if="qx"
              >保存记录</el-button
            >
          </div>
        </div>
        <hr
          style="
            background-color: #eaeaea;
            color: #eaeaea;
            height: 1px;
            border: 1px none #000000;
          "
        />
        <div>
          <!-- 增加一层 el-form表单，可以数据校验 -->
          <el-form
            ref="inputCustLinkForm4"
            :model="inputCustLinkObj4"
            :rules="rules3"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="所属客户名称">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 800px"
                    :disabled="true"
                    v-model="myCustName"
                    placeholder="请输入客户名称"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="联系人姓名" prop="linkName">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj4.linkName"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="性别" prop="sex">
                  <el-select
                    v-model="inputCustLinkObj4.sex"
                    placeholder="请选择性别"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in sexs"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="部门" prop="department">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj4.department"
                    placeholder="请输入部门"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="职务" prop="job">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj4.job"
                    placeholder="请输入职务"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!--   &nbsp;   &ensp;  &emsp;  &thinsp；       -->
            <el-row>
              <el-col :span="6">
                <el-form-item
                  label="关系程度"
                  prop="relDegree"
                  style="margin-left: 22px"
                >
                  <el-select
                    v-model="inputCustLinkObj4.relDegree"
                    placeholder="请选择关系程度"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in relDegrees"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="权能" prop="power">
                  <el-select
                    v-model="inputCustLinkObj4.power"
                    placeholder="请选择权能"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in powers"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="爱好"
                  prop="hobby"
                  style="margin-left: 10px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 448px"
                    v-model="inputCustLinkObj4.hobby"
                    placeholder="请输入爱好"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="办公地址"
                  prop="officeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj4.officeAddress"
                    placeholder="请输入办公地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  label="办公电话"
                  prop="telephone"
                  style="margin-left: 12px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj4.telephone"
                    placeholder="请输入办公电话"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="家庭地址"
                  prop="homeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj4.homeAddress"
                    placeholder="请输入家庭地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="联系方式" prop="phone">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj4.phone"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="备注描述"
                  prop="remark"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="textarea"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj4.remark"
                    placeholder="请输入备注信息"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>

      <!-- 编辑联系人5 -->
      <el-card
        v-if="Link5"
        class="box-card"
        style="
          margin-top: 10px;
          margin-left: 0px;
          margin-right: 0px;
          margin-bottom: 0px;
        "
      >
        <div style="display: flex; justify-content: space-between">
          <div style="font-weight: bold">
            联系人: {{ inputCustLinkObj5.linkName }}
          </div>
          <div>
            <el-button
              size="mini"
              type="danger"
              @click="DeleteLinkRecord(5)"
              v-if="qx"
              >删除记录</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="SaveLinkRecord(5)"
              v-if="qx"
              >保存记录</el-button
            >
          </div>
        </div>
        <hr
          style="
            background-color: #eaeaea;
            color: #eaeaea;
            height: 1px;
            border: 1px none #000000;
          "
        />
        <div>
          <!-- 增加一层 el-form表单，可以数据校验 -->
          <el-form
            ref="inputCustLinkForm5"
            :model="inputCustLinkObj5"
            :rules="rules3"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="所属客户名称">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 800px"
                    :disabled="true"
                    v-model="myCustName"
                    placeholder="请输入客户名称"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="联系人姓名" prop="linkName">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj5.linkName"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="性别" prop="sex">
                  <el-select
                    v-model="inputCustLinkObj5.sex"
                    placeholder="请选择性别"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in sexs"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="部门" prop="department">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj5.department"
                    placeholder="请输入部门"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="职务" prop="job">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj5.job"
                    placeholder="请输入职务"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!--   &nbsp;   &ensp;  &emsp;  &thinsp；       -->
            <el-row>
              <el-col :span="6">
                <el-form-item
                  label="关系程度"
                  prop="relDegree"
                  style="margin-left: 22px"
                >
                  <el-select
                    v-model="inputCustLinkObj5.relDegree"
                    placeholder="请选择关系程度"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in relDegrees"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="权能" prop="power">
                  <el-select
                    v-model="inputCustLinkObj5.power"
                    placeholder="请选择权能"
                    size="mini"
                    style="width: 150px"
                  >
                    <el-option
                      v-for="item in powers"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code * 1"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item
                  label="爱好"
                  prop="hobby"
                  style="margin-left: 10px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 448px"
                    v-model="inputCustLinkObj5.hobby"
                    placeholder="请输入爱好"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="办公地址"
                  prop="officeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj5.officeAddress"
                    placeholder="请输入办公地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  label="办公电话"
                  prop="telephone"
                  style="margin-left: 12px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj5.telephone"
                    placeholder="请输入办公电话"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="16">
                <el-form-item
                  label="家庭地址"
                  prop="homeAddress"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj5.homeAddress"
                    placeholder="请输入家庭地址"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="联系方式" prop="phone">
                  <el-input
                    type="text"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 150px"
                    v-model="inputCustLinkObj5.phone"
                    placeholder="请输入联系方式"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="备注描述"
                  prop="remark"
                  style="margin-left: 22px"
                >
                  <el-input
                    type="textarea"
                    size="mini"
                    prefix-icon="el-icon-edit"
                    style="width: 600px"
                    v-model="inputCustLinkObj5.remark"
                    placeholder="请输入备注信息"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </el-dialog>

    <!-- 弹出框  assignDialogVisible:是否弹出   指派销售经理  -->
    <el-dialog
      title="指派销售经理"
      :visible.sync="assignDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form ref="inputAssignForm" :model="inputAssignObj" :rules="rules2">
          <el-row>
            <el-col :span="24">
              <el-form-item label="客户名称" prop="custName">
                <el-input
                  type="text"
                  size="mini"
                  style="width: 340px"
                  readonly="true"
                  v-model="inputAssignObj.custName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="指派给" prop="manager">
                <el-select
                  v-model="inputAssignObj.manager"
                  multiple
                  placeholder="请指派销售经理"
                  size="mini"
                  @change="AssignEdit"
                  style="width: 340px"
                >
                  <el-option
                    v-for="item in custManagers"
                    :key="item.id"
                    :label="item.uname"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAssignRecord">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看位置弹窗 -->
    <el-dialog
      title="客户位置"
      :visible.sync="viewLocationDialogVisible"
      width="800px"
    >
      <div v-if="viewLocationData" class="location-info">
        <div class="location-name">{{ viewLocationData.custName }}</div>
        <div class="location-address">{{ viewLocationData.address || '暂无地址' }}</div>
        <div class="location-coords">
          经度: {{ viewLocationData.longitude }} &nbsp;&nbsp; 纬度: {{ viewLocationData.latitude }}
        </div>
      </div>
      <div id="viewLocationMapList" class="view-map-container">
        <div v-if="viewMapLoading" class="map-loading">
          <i class="el-icon-loading"></i>
          <span>地图加载中...</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewLocationDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 地图定位弹窗 -->
    <el-dialog
      :title="mapLocationMode === 'bind' ? '地图搜索' : '地图定位'"
      :visible.sync="bindLocationDialogVisible"
      width="90%"
      top="3%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="bind-cust-dialog"
    >
      <div class="bind-search-bar">
        <span class="bind-hint">
          {{ mapLocationMode === 'bind' ? '输入客户名称搜索，或直接点击地图选点' : '搜索并选择地址，或直接点击地图选点' }}
        </span>
      </div>
      <div class="bind-search-row">
        <el-input
          v-model="bindSearchKeyword"
          placeholder="请输入要搜索的位置"
          prefix-icon="el-icon-search"
          size="small"
          style="width: 400px"
          @keyup.enter.native="searchPlace"
        >
        </el-input>
        <el-button type="primary" size="small" @click="searchPlace" style="margin-left: 10px">
          搜索
        </el-button>
      </div>

      <div class="bind-main">
        <!-- 左侧搜索结果列表 -->
        <div class="bind-results">
          <div class="bind-results-header">搜索结果</div>
          <div class="bind-results-list">
            <div
              v-for="(item, index) in bindSearchResults"
              :key="index"
              :class="['bind-result-item', { 'active': bindSelectedIndex === index }]"
              @click="selectSearchResult(index)"
            >
              <div class="result-name">{{ item.name }}</div>
              <div class="result-address">{{ item.address }}</div>
              <div class="result-location">
                <i class="el-icon-location-outline"></i>
                <span>{{ item.district }} {{ item.businessArea }}</span>
              </div>
            </div>
            <div v-if="bindSearchResults.length === 0 && bindHasSearched" class="empty-tip">
              未找到相关结果
            </div>
          </div>
        </div>

        <!-- 右侧地图 -->
        <div class="bind-map-area">
          <div class="map-info-bar">位置信息</div>
          <div id="bindLocationMapList" class="amap-container">
            <div v-if="bindMapLoading" class="map-loading">
              <i class="el-icon-loading"></i>
              <span>地图加载中...</span>
            </div>
            <div v-if="!bindMapLoading && !bindSelectedResult" class="map-hint">
              <i class="el-icon-location"></i>
              <span>请点击地图选择位置</span>
            </div>
          </div>
          <div v-if="bindSelectedResult" class="selected-info">
            <div class="selected-name">{{ bindSelectedResult.name }}</div>
            <div class="selected-address">{{ bindSelectedResult.address }}</div>
            <div class="selected-coords">
              经度: {{ bindSelectedResult.longitude }} &nbsp;&nbsp; 纬度: {{ bindSelectedResult.latitude }}
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="bindLocationDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="!bindSelectedResult"
          @click="confirmBindLocation"
        >
          <i :class="mapLocationMode === 'bind' ? 'el-icon-link' : 'el-icon-circle-check'"></i> {{ mapLocationMode === 'bind' ? '绑定客户' : '确认位置' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import { updateLinkman, fuzzySearch } from "../../api/cust/index";
import XLSX from "xlsx";
import { postProvinces, postCitys } from "../../api/SlmsData/Supplier";
export default {
  name: "CustList",
  data() {
    return {
      saleManagers: [], // 销售经理对象列表
      qx: true, // 总经理、销售总监编辑的权限
      zjl_qx: true, // 总经理的权限
      qx1: false, // 销售总监指派客户的权限    --- 2024.10.23 增加总经理指派客户的权限    --- 2024.10.24 增加四个销售部门经理个人账号的权限
      Link1: false,
      Link2: false,
      Link3: false,
      Link4: false,
      Link5: false,
      add_lxr: true,
      LinkCount: null,
      showClo: false,
      queryData: [], // 存放查询结果 -- 客户列表
      queryLinkData: [], // 存放查询结果 -- 客户联系人列表
      industry: null, // 查询使用
      custName: "", // 查询使用
      myCustName: "", // 客户联系人弹出框 显示用
      myCustId: null, // 传递 custId 给 联系人模块 查询 该客户id下的所有联系人
      industrys: [], // 行业id-行业名称下拉框
      provinces: [], // 省份下拉框
      managers: [], // 指派销售经理下拉框
      citys: [], // 地市下拉框
      sexs: [], // 性别下拉框
      relDegrees: [], // 关系程度下拉框
      powers: [], // 权能下拉框
      custManagers: [], // 客户经理下拉框
      custManagerId: "", // 客户经理下拉框  选择
      region: "", // 所在区域筛选（省-市组合值，如 "360000-360100"，无城市时为 "360000-"）
      regionOptions: [], // 所在区域下拉框选项（来自列表数据去重，只增不减）
      originalData: [], // 原始数据
      loading: false,
      total: 0,
      page: 1,
      limit: 10,
      title: "",
      dialogVisible: false,
      updateDialogVisible: false,
      assignDialogVisible: false,
      linkmanDialogVisible: false,
      viewLocationDialogVisible: false,
      viewLocationData: null,
      similarDialogVisible: false,
      similarCustomerList: [],
      currentInputCustName: '',
      viewMapLoading: true,
      viewMapInstance: null,
      viewMarkerInstance: null,
      bindLocationDialogVisible: false,
      bindLocationData: null,
      mapLocationMode: 'bind', // 'bind' for binding to existing customer, 'add'/'update' for form usage
      bindSearchKeyword: '',
      bindSearchResults: [],
      bindSelectedResult: null,
      bindSelectedIndex: -1,
      bindHasSearched: false,
      bindMapLoading: true,
      bindMapInstance: null,
      bindMarkerInstance: null,
      bindSearchCity: '',
      // 新增客户对象
      inputCustObj: {
        id: null,
        custName: "",
        province: "",
        city: "",
        industry: null,
        address: "",
        longitude: "",
        latitude: "",
        postCode: "",
        phone: "",
      },
      // 修改客户对象
      inputXgCustObj: {
        id: null,
        custName: "",
        province: "",
        city: "",
        industry: "",
        address: "",
        longitude: "",
        latitude: "",
        postCode: "",
        phone: "",
        createTime: null,
        updateTime: null,
      },
      // 指派销售经理对象   只在提交的时候使用  提交前将  inputAssignObj 赋值给  inputAssignObj2
      inputAssignObj2: {
        id: null, // 客户表主键         需提交
        userIds: [], // 客户表-销售人员    需提交
      },
      // 指派销售经理对象
      inputAssignObj: {
        id: null, // 客户表主键         需提交
        userId: null, // 客户表-销售人员    需提交
        manager: [], // 该字段无需提交
        custName: "", // 该字段无需提交
      },

      rules: {
        custName: [
          {
            required: true,
            message: "请输入客户名称",
            trigger: "blur",
          },
        ],
        industry: [
          {
            required: true,
            message: "请选择所属行业",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "请选择地市",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入客户地址",
            trigger: "blur",
          },
        ],
      },
      rules2: {
        manager: [
          {
            required: true,
            message: "请指派销售经理",
            trigger: "blur",
          },
        ],
      },
      // 编辑客户联系人对象    添加用的
      inputCustLinkObj: {
        id: "", // 客户联系人id
        custId: "",
        linkName: "",
        sex: "",
        department: "",
        job: "",
        relDegree: "",
        power: "",
        hobby: "",
        officeAddress: "",
        telephone: "",
        homeAddress: "",
        phone: "",
        remark: "",
      },
      // 编辑客户联系人对象1~5
      inputCustLinkObj1: {
        id: "", // 客户联系人id
        custId: "",
        linkName: "",
        sex: "",
        department: "",
        job: "",
        relDegree: "",
        power: "",
        hobby: "",
        officeAddress: "",
        telephone: "",
        homeAddress: "",
        phone: "",
        remark: "",
      },
      inputCustLinkObj2: {
        id: "", // 客户联系人id
        custId: "",
        linkName: "",
        sex: "",
        department: "",
        job: "",
        relDegree: "",
        power: "",
        hobby: "",
        officeAddress: "",
        telephone: "",
        homeAddress: "",
        phone: "",
        remark: "",
      },
      inputCustLinkObj3: {
        id: "", // 客户联系人id
        custId: "",
        linkName: "",
        sex: "",
        department: "",
        job: "",
        relDegree: "",
        power: "",
        hobby: "",
        officeAddress: "",
        telephone: "",
        homeAddress: "",
        phone: "",
        remark: "",
      },
      inputCustLinkObj4: {
        id: "", // 客户联系人id
        custId: "",
        linkName: "",
        sex: "",
        department: "",
        job: "",
        relDegree: "",
        power: "",
        hobby: "",
        officeAddress: "",
        telephone: "",
        homeAddress: "",
        phone: "",
        remark: "",
      },
      inputCustLinkObj5: {
        id: "", // 客户联系人id
        custId: "",
        linkName: "",
        sex: "",
        department: "",
        job: "",
        relDegree: "",
        power: "",
        hobby: "",
        officeAddress: "",
        telephone: "",
        homeAddress: "",
        phone: "",
        remark: "",
      },

      rules3: {
        linkName: [
          {
            required: true,
            message: "请输入联系人姓名",
            trigger: "blur",
          },
        ],
        department: [
          {
            required: true,
            message: "请输入所属部门",
            trigger: "blur",
          },
        ],
        job: [
          {
            required: true,
            message: "请选择职务",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.initDim();
    this.quanxian();
    this.quanxian1();
    this.zjl_quanxian();
    // 保存原始数据
    console.log(this.originalData, "原始数据"); // 打印过滤后的表格数据
    this.$nextTick(() => {
      this.initData();
    });
  },
  methods: {
    onSearch() {
      this.page = 1;
      this.initData();
    },
    // 将本次查询结果中出现的"省-市"区域并入"所在区域"下拉选项（只增不减，按组合值去重）
    collectRegions(rows) {
      if (!Array.isArray(rows) || rows.length === 0) {
        return;
      }
      const existed = new Set(this.regionOptions.map((item) => item.value));
      rows.forEach((row) => {
        if (!row) {
          return;
        }
        const provinceCode = row.province;
        const provinceName = row.provinceName;
        if (!provinceCode || !provinceName) {
          return;
        }
        const value = provinceCode + "-" + (row.city || "");
        const label = row.cityName
          ? provinceName + "-" + row.cityName
          : provinceName;
        if (existed.has(value)) {
          return;
        }
        existed.add(value);
        this.regionOptions.push({ value: value, label: label });
      });
    },
    // 新增筛选方法
    openMapLocation(mode) {
      this.mapLocationMode = mode
      this.bindLocationDialogVisible = true
      this.bindSearchResults = []
      this.bindSelectedResult = null
      this.bindSelectedIndex = -1
      this.bindHasSearched = false
      this.bindMapLoading = true
      
      if (mode === 'add') {
        this.bindSearchKeyword = this.inputCustObj.custName || ''
      } else {
        this.bindSearchKeyword = this.inputXgCustObj.custName || ''
      }
      
      this.$nextTick(() => {
        this.initBindMap()
        if (this.bindSearchKeyword) {
          setTimeout(() => {
            this.searchPlace()
          }, 500)
        }
      })
    },
    viewLocation(row) {
      if (row.latitude && row.longitude) {
        this.viewLocationData = row
        this.viewLocationDialogVisible = true
        this.viewMapLoading = true
        this.$nextTick(() => {
          this.initViewMap()
        })
      } else {
        this.bindLocationData = row
        this.bindLocationDialogVisible = true
        this.bindSearchKeyword = row.custName || ''
        this.bindSearchResults = []
        this.bindSelectedResult = null
        this.bindMapLoading = true
        if (row.provinceName && row.cityName) {
          this.bindSearchCity = row.provinceName + row.cityName
        } else if (row.provinceName) {
          this.bindSearchCity = row.provinceName
        } else {
          this.bindSearchCity = ''
        }
        this.$nextTick(() => {
          this.initBindMap()
          if (this.bindSearchKeyword) {
            setTimeout(() => {
              this.searchPlace()
            }, 500)
          }
        })
      }
    },
    initViewMap() {
      this.$nextTick(() => {
        const mapContainer = document.getElementById('viewLocationMapList')
        if (!mapContainer) return
        if (this.viewMapInstance) {
          this.viewMapInstance.destroy()
          this.viewMapInstance = null
        }
        if (typeof AMap === 'undefined') {
          console.error('高德地图SDK未加载')
          this.$message.error('地图服务未加载，请检查网络连接')
          return
        }
        this.viewMapInstance = new AMap.Map('viewLocationMapList', {
          viewMode: '2D',
          zoom: 15,
          center: [this.viewLocationData.longitude, this.viewLocationData.latitude]
        })
        this.viewMarkerInstance = new AMap.Marker({
          position: [this.viewLocationData.longitude, this.viewLocationData.latitude],
          title: this.viewLocationData.custName
        })
        this.viewMapInstance.add(this.viewMarkerInstance)
        this.viewMapInstance.on('complete', () => {
          this.viewMapLoading = false
        })
      })
    },
    initBindMap() {
      this.$nextTick(() => {
        const mapContainer = document.getElementById('bindLocationMapList')
        if (!mapContainer) return
        if (this.bindMapInstance) {
          this.bindMapInstance.destroy()
          this.bindMapInstance = null
          this.bindMarkerInstance = null
        }
        if (typeof AMap === 'undefined') {
          console.error('高德地图SDK未加载')
          this.$message.error('地图服务未加载，请检查网络连接')
          return
        }
        this.bindMapInstance = new AMap.Map('bindLocationMapList', {
          viewMode: '2D',
          zoom: 12,
          center: [115.9, 27.6]
        })
        this.bindMarkerInstance = null
        
        // 地图点击事件 - 点击地图选点
        this.bindMapInstance.on('click', (e) => {
          const lng = e.lnglat.getLng()
          const lat = e.lnglat.getLat()
          
          // 如果已有标记点，先移除
          if (this.bindMarkerInstance) {
            this.bindMapInstance.remove(this.bindMarkerInstance)
          }
          
          // 添加新的标记点
          this.bindMarkerInstance = new AMap.Marker({
            position: [lng, lat],
            title: '已选位置'
          })
          this.bindMapInstance.add(this.bindMarkerInstance)
          this.bindMapInstance.setZoomAndCenter(16, [lng, lat])
          
          // 使用逆地理编码获取地址
          const geocoder = new AMap.Geocoder()
          geocoder.getAddress([lng, lat], (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              const address = result.regeocode.formattedAddress
              this.bindSelectedResult = {
                name: '手动选择位置',
                address: address,
                district: result.regeocode.addressComponent.district || '',
                businessArea: result.regeocode.aois ? result.regeocode.aois[0]?.name : '',
                longitude: lng,
                latitude: lat
              }
              this.bindSelectedIndex = -1
            } else {
              this.bindSelectedResult = {
                name: '手动选择位置',
                address: '未知地址',
                district: '',
                businessArea: '',
                longitude: lng,
                latitude: lat
              }
              this.bindSelectedIndex = -1
            }
          })
        })
        
        this.bindMapInstance.on('complete', () => {
          this.bindMapLoading = false
        })
      })
    },
    searchPlace() {
      if (!this.bindSearchKeyword || !this.bindSearchKeyword.trim()) {
        this.$message.warning('请输入搜索关键词')
        return
      }
      if (typeof AMap === 'undefined') {
        this.$message.error('地图服务未加载，请检查网络连接')
        return
      }
      this.bindHasSearched = true
      const keyword = this.bindSearchKeyword.trim()
      AMap.plugin('AMap.PlaceSearch', () => {
        const placeSearch = new AMap.PlaceSearch({
          city: this.bindSearchCity || '全国',
          citylimit: true,
          pageSize: 10,
          pageIndex: 1
        })
        const searchKeyword = this.bindSearchCity ? keyword + ' ' + this.bindSearchCity : keyword
        placeSearch.search(searchKeyword, (status, result) => {
          console.log('搜索状态:', status, result)
          if (status === 'complete' && result.poiList && result.poiList.pois) {
            this.bindSearchResults = result.poiList.pois.map(poi => ({
              name: poi.name,
              address: poi.address,
              location: poi.location,
              longitude: poi.location.lng,
              latitude: poi.location.lat,
              district: poi.district || '',
              businessArea: poi.businessArea || ''
            }))
          } else if (status === 'no_data' || !result.poiList) {
            this.bindSearchResults = []
          } else {
            this.bindSearchResults = []
            this.$message.warning('搜索失败，请重试')
          }
        })
      })
    },
    selectSearchResult(index) {
      this.bindSelectedResult = this.bindSearchResults[index]
      this.bindSelectedIndex = index
      if (this.bindMarkerInstance) {
        this.bindMapInstance.remove(this.bindMarkerInstance)
      }
      this.bindMarkerInstance = new AMap.Marker({
        position: [this.bindSelectedResult.longitude, this.bindSelectedResult.latitude],
        title: this.bindSelectedResult.name
      })
      this.bindMapInstance.add(this.bindMarkerInstance)
      this.bindMapInstance.setCenter([this.bindSelectedResult.longitude, this.bindSelectedResult.latitude])
      this.bindMapInstance.setZoom(16)
    },
    confirmBindLocation() {
      if (!this.bindSelectedResult) {
        this.$message.warning('请选择一个位置')
        return
      }
      // 表单模式：直接回显到表单
      if (this.mapLocationMode === 'add' || this.mapLocationMode === 'update') {
        if (this.mapLocationMode === 'add') {
          this.inputCustObj.address = this.bindSelectedResult.address
          this.inputCustObj.longitude = this.bindSelectedResult.longitude
          this.inputCustObj.latitude = this.bindSelectedResult.latitude
        } else {
          this.inputXgCustObj.address = this.bindSelectedResult.address
          this.inputXgCustObj.longitude = this.bindSelectedResult.longitude
          this.inputXgCustObj.latitude = this.bindSelectedResult.latitude
        }
        this.$message.success('位置信息已填入表单')
        this.bindLocationDialogVisible = false
        return
      }
      // 绑定模式：提交API更新地址
      this.$confirm(
        `确认将 "${this.bindSelectedResult.name}" 为客户的地址吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(async () => {
        try {
          const resp = await this.putRequest('/cust/updateCustLocation', {
            id: this.bindLocationData.id,
            address: this.bindSelectedResult.address,
            longitude: this.bindSelectedResult.longitude,
            latitude: this.bindSelectedResult.latitude
          })
          if (resp && resp.code === 200) {
            this.$message.success('绑定成功')
            this.bindLocationDialogVisible = false
            this.initData()
          }
        } catch (error) {
          console.error('绑定地址失败:', error)
          this.$message.error('绑定失败')
        }
      }).catch(() => {})
    },
    downloadExcel() {
      var wb = XLSX.utils.table_to_book(document.querySelector("#mytable")); //mytable为表格的id名
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream",
          }),
          "客户列表清单.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    AssignEdit() {
      const mystr = this.inputAssignObj.manager + ",mystr";
      var flag = mystr.search("111");
      if (flag !== -1) {
        this.inputAssignObj.manager = [111];
      } else {
      }
    },
    // ... existing code ...
    // 提取公共的权限检查逻辑到一个单独的方法
    checkPermissions(roleIds, targetIds, permissionFlag) {
      const userRoleId = window.sessionStorage.getItem("userRoleId");
      if (userRoleId) {
        if (this.doesItContain(targetIds).length > 0) {
          this[permissionFlag] = permissionFlag === "qx1";
        }
      }
    },
    quanxian() {
      this.checkPermissions(
        window.sessionStorage.getItem("userRoleId"),
        [8, 17],
        "qx"
      );
    },
    zjl_quanxian() {
      this.checkPermissions(
        window.sessionStorage.getItem("userRoleId"),
        [8],
        "zjl_qx"
      );
    },
    quanxian1() {
      this.checkPermissions(
        window.sessionStorage.getItem("userRoleId"),
        [1, 8, 17],
        "qx1"
      );
    },
    DeleteLinkRecord(flag) {
      // ... existing code ...    DeleteLinkRecord(flag) {
      const inputCustLinkObjs = [
        this.inputCustLinkObj1,
        this.inputCustLinkObj2,
        this.inputCustLinkObj3,
        this.inputCustLinkObj4,
        this.inputCustLinkObj5,
      ];

      if (flag >= 1 && flag <= 5) {
        this.deleteRecordNew(inputCustLinkObjs[flag - 1]);
      }
    },
    SaveLinkRecord(flag) {
      const inputCustLinkForms = [
        this.$refs["inputCustLinkForm1"],
        this.$refs["inputCustLinkForm2"],
        this.$refs["inputCustLinkForm3"],
        this.$refs["inputCustLinkForm4"],
        this.$refs["inputCustLinkForm5"],
      ];

      const inputCustLinkObjs = [
        this.inputCustLinkObj1,
        this.inputCustLinkObj2,
        this.inputCustLinkObj3,
        this.inputCustLinkObj4,
        this.inputCustLinkObj5,
      ];

      if (flag >= 1 && flag <= 5) {
        inputCustLinkForms[flag - 1].validate((valid) => {
          if (valid) {

            this.postRequest2(
              "/cust/update_linkman",
              inputCustLinkObjs[flag - 1]
            ).then((resp) => {
              if (resp) {
                // this.updateDialogVisible = false  // 修改联系人后关闭
              }
            });
          }
        });
      }
    },
    updateRecordView(data) {
      // 双击表格记录
      // 第一个参数 index 无用 随便赋值为1
      this.updateCustInfo(1, data);
      this.myCustName = this.inputXgCustObj.custName;
      this.getLinkData(data.id);
    },
    ViewAddLinkRecord(data) {
      this.linkmanDialogVisible = true;
      if (data.custName) {
        // 客户列表 操作 新增联系人
        this.myCustName = data.custName;
        this.inputCustLinkObj.custId = data.id;
      } else {
        this.myCustName = this.inputCustObj.custName;
      }
    },
    async provinceChange() {
      this.inputCustObj.city = "";
      this.citys = await postCitys(this.inputCustObj.province);
    },
    provinceChange2() {
      this.getRequest(
        "/dim/queryAllCity?province=" + this.inputXgCustObj.province
      ).then((resp) => {
        if (resp) {
          console.log(resp);
          this.citys = resp;
        }
      });
    },
    async getLinkData(custId) {
      this.provinces = await postProvinces();
      this.citys = await postCitys("360000");

      const linkFlags = ["Link1", "Link2", "Link3", "Link4", "Link5"];
      const inputCustLinkObjs = [
        "inputCustLinkObj1",
        "inputCustLinkObj2",
        "inputCustLinkObj3",
        "inputCustLinkObj4",
        "inputCustLinkObj5",
      ];

      linkFlags.forEach((flag, index) => {
        this[flag] = false;
        this[inputCustLinkObjs[index]] = null;
      });

      let url = "/cust/link_man_list/?page=1&limit=20";
      if (custId) {
        url += "&custId=" + custId;
      }

      this.getRequest(url).then((resp) => {
        if (resp) {
          this.queryLinkData = resp.data;
          console.log(this.queryLinkData);

          this.LinkCount = resp.count;

          if (this.LinkCount) {
            for (let i = 0; i < this.LinkCount; i++) {
              this[linkFlags[i]] = true;
              this[inputCustLinkObjs[i]] = this.queryLinkData[i];
              this[inputCustLinkObjs[i]].sex = this.queryLinkData[i].sex;
              this[inputCustLinkObjs[i]].relDegree =
                this.queryLinkData[i].relDegree;
              this[inputCustLinkObjs[i]].power =
                this.queryLinkData[i].power ;
            }
          }
        }
      });
    },
    initLinkData() {
      let url = "/cust/link_man_list/?page=1&limit=20";

      if (this.myCustId) {
        url += "&custId=" + this.myCustId;
      }
      this.getRequest(url).then((resp) => {
        if (resp) {
          this.queryLinkData = resp.data;
        }
      });
    },
    initData() {
      this.loading = true;
      let url = "/cust/list/?page=" + this.page + "&limit=" + this.limit;

      if (this.custName) {
        url += "&custName=" + this.custName;
      }
      if (this.industry) {
        url += "&industry=" + this.industry;
      }
      if (this.custManagerId) {
        url += "&custManagerId=" + this.custManagerId;
      }
      if (this.region) {
        const regionParts = this.region.split("-");
        url += "&province=" + regionParts[0];
        if (regionParts[1]) {
          url += "&city=" + regionParts[1];
        }
      }
      this.getRequest(url).then((resp) => {
        this.loading = true;
        if (resp) {
          this.queryData = resp.data;
          this.total = resp.count;
          this.originalData = [...this.queryData]; // 深拷贝
          this.collectRegions(this.queryData);
          this.loading = false;
        }
      });
    },
    initDim() {
      //  客户经理
      if (!window.sessionStorage.getItem("managers")) {
        this.postRequest("/user/queryAllSales").then((resp) => {
          if (resp) {
            this.custManagers = resp;
            this.saveDictCache("managers", resp);
          }
        });
      } else {
        this.custManagers = this.dictCache("managers");
      }
      if (!window.sessionStorage.getItem("industrys")) {
        this.postRequest("/dim/dim_table_char/industry").then((resp) => {
          if (resp) {
            this.industrys = resp.result;
            this.saveDictCache("industrys", resp.result);
          }
        });
      } else {
        this.industrys = this.dictCache("industrys");
      }
      // 性别
      if (!window.sessionStorage.getItem("sexs")) {
        this.postRequest("/dim/dim_table_char/sex").then((resp) => {
          if (resp) {
            this.sexs = resp.result;
            this.saveDictCache("sexs", resp.result);
          }
        });
      } else {
        this.sexs = this.dictCache("sexs");
      }
      //  权能
      if (!window.sessionStorage.getItem("powers")) {
        this.postRequest("/dim/dim_table_char/power").then((resp) => {
          if (resp) {
            this.powers = resp.result;
            this.saveDictCache("powers", resp.result);
          }
        });
      } else {
        this.powers = this.dictCache("powers");
      }
      //  关系程度
      if (!window.sessionStorage.getItem("relDegrees")) {
        this.postRequest("/dim/dim_table_char/rel_degree").then((resp) => {
          if (resp) {
            this.relDegrees = resp.result;
            this.saveDictCache("relDegrees", resp.result);
          }
        });
      } else {
        this.relDegrees = this.dictCache("relDegrees");
      }
      this.tableKey = Math.random(); // 重新渲染表格
      this.custManager = null; // 清空客户经理下拉框
    },
    async addCust() {
      this.inputCustObj = {
        id: null,
        custName: "",
        province: "360000",
        city: "360100",
        industry: null,
        address: "",
        longitude: "",
        latitude: "",
        postCode: "",
        phone: "",
      };
      this.title = "添加新客户";
      this.dialogVisible = true;
      this.add_lxr = true;
      this.myCustId = null;
      this.queryLinkData = null;
      this.provinces = await postProvinces();
      this.citys = await postCitys(this.inputCustObj.province);
    },
    doChanceLxr() {
      this.linkmanDialogVisible = false;
      this.inputCustLinkObj = {
        id: null,
        custId: null,
        linkName: "",
        sex: "",
        department: "",
        job: "",
        relDegree: null,
        power: null,
        hobby: "",
        officeAddress: "",
        telephone: "",
        homeAddress: "",
        phone: "",
        remark: "",
      };
    },
    doChance() {
      this.dialogVisible = false;
      this.updateDialogVisible = false;
      this.assignDialogVisible = false;
    },
    async doAddRecord() {
      this.$refs["inputCustForm"].validate(async (valid) => {
        if (valid) {
          const keyword = this.inputCustObj.custName;
          try {
            const searchResp = await fuzzySearch(keyword);
            const dataArray = searchResp && searchResp.data && Array.isArray(searchResp.data) ? searchResp.data : [];
            if (dataArray.length > 0) {
              this.currentInputCustName = keyword;
              const sortedData = [...dataArray].sort((a, b) => {
                return Math.abs(1 - a.score) - Math.abs(1 - b.score);
              });
              const list = sortedData.map(item => {
                const custInfo = item.cust || item;
                return {
                  name: custInfo.custName || custInfo.uname || custInfo.name || '',
                  score: item.score,
                  industry: custInfo.industryName || custInfo.industry || '',
                  province: custInfo.provinceName || custInfo.province || '',
                  city: custInfo.cityName || custInfo.city || '',
                  claimStatus: custInfo.claimStatus,
                  custManagerName: custInfo.custManagerName || '',
                  address: custInfo.address || ''

                };
              });
              this.similarCustomerList = list;
              this.similarDialogVisible = true;
              return;
            }
          } catch (e) {
            console.error('相似客户查询失败:', e);
          }
          this.doAddCustDirect();
        }
      });
    },
    doAddCustDirect() {
      this.$refs["inputCustForm"].validate((valid) => {
        if (valid) {
          this.postRequest2("/cust/add", this.inputCustObj).then((resp) => {
            if (resp) {
              this.inputCustLinkObj.custId = resp.result;
              this.myCustId = resp.result;
              this.initData();
              this.add_lxr = false;
            }
          });
        }
      });
      this.initData();
    },
    confirmAddAfterSimilarCheck() {
      this.similarDialogVisible = false;
      this.doAddCustDirect();
    },
    doAssignRecord() {
      this.$refs["inputAssignForm"].validate((valid) => {
        // alert(valid)
        this.inputAssignObj2.id = this.inputAssignObj.id;
        this.inputAssignObj2.userIds = this.inputAssignObj.manager;
        if (valid) {
          //验证通过
          this.postRequest2("/cust/assign", this.inputAssignObj2).then(
            (resp) => {
              if (resp) {
                this.assignDialogVisible = false;

                this.initData();
              }
            }
          );
        }
      });
      this.assignDialogVisible = false;
      this.initData();
    },
    doUpdateRecord() {
      this.$refs["inputXgCustForm"].validate((valid) => {
        // alert(valid)
        this.inputXgCustObj.createTime;
        if (valid) {
          //验证通过
          this.postRequest2("/cust/update", this.inputXgCustObj).then(
            (resp) => {
              if (resp) {
                this.updateDialogVisible = false; // 修改关闭
                this.initData();
              }
            }
          );
        }
      });
    },
    showEditView(data) {
      this.updateDialogVisible = true;
      this.inputXgCustObj = data;
    },
    showLinkManView(data) {
      // alert(JSON.stringify(data))
      this.linkmanDialogVisible = true;
      this.inputCustLinkObj = {
        id: "",
        custId: data.id,
        linkName: "",
        sex: "",
        department: "",
        job: "",
        relDegree: "",
        power: "",
        hobby: "",
        officeAddress: "",
        telephone: "",
        homeAddress: "",
        phone: "",
        remark: "",
      };
      this.myCustName = data.custName;
      this.myCustId = data.id;
      this.initLinkData();
      // this.inputCustLinkObj.custId = data.custId
    },
    currentChange(currentPage) {
      this.page = currentPage;
      this.initData();
    },
    sizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.initData();
    },
    updateCustInfo(index, row) {
      console.log(index); //  当前这个参数 无用
      // alert(JSON.stringify(row))
      this.updateDialogVisible = true;
      this.inputXgCustObj = row;
      this.inputXgCustObj.industry = this.inputXgCustObj.industry + ""; // 下拉无法回显 转换为同一类型
    },
    assignManager(index, row) {
      // alert(JSON.stringify(row))

      this.inputAssignObj.id = row.id; // 客户ID
      this.inputAssignObj.custName = row.custName; //客户名称
      this.inputAssignObj2.userId = null;
      this.inputAssignObj.userId = null;
      this.inputAssignObj.manager = null;

      let url = "/cust/cust_sale_list?custId=" + row.id;
      this.getRequest(url).then((resp) => {
        if (resp) {
          this.saleManagers = resp.data;
          this.inputAssignObj.manager = [];
          this.saleManagers.forEach((r) => {
            this.inputAssignObj.manager.push(r.custManagerId);
          });

          this.assignDialogVisible = true;
          // alert("this.inputAssignObj.manager="+this.inputAssignObj.manager)
        }
      });
    },
    beforeHandleCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command,
      };
    },
    getIndustryClass(industryName) {
      const industryMap = {
        '企业': 'industry-enterprise',
        '政府': 'industry-government',
        '教育': 'industry-education',
        '金融': 'industry-finance',
        '医疗': 'industry-medical',
        '个人': 'industry-personal',
        '合作商': 'industry-partner',
      };
      return industryMap[industryName] || '';
    },
    handleCommand(command) {
      switch (command.command) {
        case "a": // 修改客户信息
          this.updateCustInfo(command.index, command.row);
          break;
        case "b": // 指派销售人员
          this.assignManager(command.index, command.row);
          break;
      }
    },
    doAddLinkRecord() {
      this.$refs["inputCustLinkForm"].validate((valid) => {
        // alert(valid)
        if (valid) {
          //验证通过
          this.postRequest2("/cust/addLinkman", this.inputCustLinkObj).then(
            (resp) => {
              if (resp) {
                this.initLinkData();
                this.inputCustLinkObj = {
                  id: null,
                  linkName: "",
                  sex: "",
                  department: "",
                  job: "",
                  relDegree: null,
                  power: null,
                  hobby: "",
                  officeAddress: "",
                  telephone: "",
                  homeAddress: "",
                  phone: "",
                  remark: "",
                };
                this.inputCustLinkObj.custId = this.myCustId;
                this.linkmanDialogVisible = false;
              }
            }
          );
        }
      });
    },
    deleteRecord(data) {
      this.$confirm(
        "此操作将永久删除 " + data.linkName + "的该条联系人明细, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.postRequest2("/cust/delete_linkman?id=" + data.id).then(
            (resp) => {
              if (resp) {
                this.initLinkData();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    deleteRecordNew(data) {
      this.$confirm(
        "此操作将永久删除 " + data.linkName + "的该条联系人明细, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.postRequest2("/cust/delete_linkman?id=" + data.id).then(
            (resp) => {
              if (resp) {
                // this.initLinkData();
                this.getLinkData(this.inputXgCustObj.id);
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
/* 行业标签样式 */
.industry-enterprise,
.industry-government,
.industry-education,
.industry-finance,
.industry-medical,
.industry-personal,
.industry-partner,
.industry-other {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: $font-size-base;
  font-weight: 500;
}

.industry-enterprise {
  background-color: #fff7e6;
  color: #fa8c16;
}

.industry-government {
  background-color: #e6f7ff;
  color: #1890ff;
}

.industry-education {
  background-color: #f6ffed;
  color: #52c41a;
}

.industry-finance {
  background-color: #fff0f6;
  color: #eb2f96;
}

.industry-medical {
  background-color: #e6fffb;
  color: #13c2c2;
}

.industry-personal {
  background-color: #f9f0ff;
  color: #722ed1;
}

.industry-partner {
  background-color: #fff7e6;
  color: #fa8c16;
}

.industry-other {
  background-color: #f0f0f0;
  color: #8c8c8c;
}

/* 查看位置弹窗样式 */
.location-info {
  padding: 12px 15px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 15px;
}

.location-info .location-name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.location-info .location-address {
  font-size: 14px;
  color: #606266;
  margin-bottom: 4px;
}

.location-info .location-coords {
  font-size: $font-size-base;
  color: #909399;
}

.view-map-container {
  width: 100%;
  height: 400px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  position: relative;
}

.map-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 10;
  color: #409eff;
}

.map-loading i {
  font-size: 32px;
  margin-bottom: 10px;
}

.map-loading span {
  font-size: 14px;
}

/* 地图定位弹窗样式 */
.bind-cust-dialog ::v-deep .el-dialog__body {
  padding: 10px 20px;
}

.bind-cust-dialog .bind-search-bar {
  margin-bottom: 10px;
}

.bind-cust-dialog .bind-search-bar .bind-hint {
  color: #909399;
  font-size: $font-size-base;
}

.bind-cust-dialog .bind-search-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.bind-cust-dialog .bind-main {
  display: flex;
  gap: 15px;
  height: 600px;
}

.bind-cust-dialog .bind-main .bind-results {
  width: 380px;
  min-width: 380px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
}

.bind-cust-dialog .bind-main .bind-results .bind-results-header {
  padding: 12px 15px;
  font-weight: bold;
  font-size: 14px;
  color: #303133;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.bind-cust-dialog .bind-main .bind-results .bind-results-list {
  flex: 1;
  overflow-y: auto;
}

.bind-cust-dialog .bind-main .bind-results .bind-results-list .bind-result-item {
  padding: 12px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
}

.bind-cust-dialog .bind-main .bind-results .bind-results-list .bind-result-item:hover {
  background: #f5f7fa;
}

.bind-cust-dialog .bind-main .bind-results .bind-results-list .bind-result-item.active {
  background: #ecf5ff;
  border-left: 3px solid #409eff;
}

.bind-cust-dialog .bind-main .bind-results .bind-results-list .bind-result-item .result-name {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bind-cust-dialog .bind-main .bind-results .bind-results-list .bind-result-item .result-address {
  font-size: $font-size-base;
  color: #909399;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bind-cust-dialog .bind-main .bind-results .bind-results-list .bind-result-item .result-location {
  font-size: $font-size-base;
  color: #c0c4cc;
}

.bind-cust-dialog .bind-main .bind-results .bind-results-list .bind-result-item .result-location i {
  margin-right: 3px;
}

.bind-cust-dialog .bind-main .bind-results .bind-results-list .empty-tip {
  text-align: center;
  padding: 40px 20px;
  color: #c0c4cc;
  font-size: 14px;
}

.bind-cust-dialog .bind-main .bind-map-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
}

.bind-cust-dialog .bind-main .bind-map-area .map-info-bar {
  padding: 12px 15px;
  font-weight: bold;
  font-size: 14px;
  color: #303133;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.bind-cust-dialog .bind-main .bind-map-area .amap-container {
  flex: 1;
  min-height: 350px;
  position: relative;
}

.bind-cust-dialog .bind-main .bind-map-area .amap-container .map-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 10;
  color: #409eff;
}

.bind-cust-dialog .bind-main .bind-map-area .amap-container .map-loading i {
  font-size: 32px;
  margin-bottom: 10px;
}

.bind-cust-dialog .bind-main .bind-map-area .amap-container .map-loading span {
  font-size: 14px;
}

.bind-cust-dialog .bind-main .bind-map-area .selected-info {
  padding: 12px 15px;
  background: #fff;
  border-top: 1px solid #e4e7ed;
}

.bind-cust-dialog .bind-main .bind-map-area .selected-info .selected-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 4px;
}

.bind-cust-dialog .bind-main .bind-map-area .selected-info .selected-address {
  font-size: $font-size-base;
  color: #909399;
  margin-bottom: 4px;
}

.bind-cust-dialog .bind-main .bind-map-area .selected-info .selected-coords {
  font-size: $font-size-base;
  color: #c0c4cc;
}

.bind-cust-dialog .dialog-footer {
  text-align: right;
  padding: 12px 0;
  margin-top: 10px;
}
</style>
